import React, { useState } from 'react';
import Style from './Contact.module.css';
import { Row, Col, Form, Button, Alert } from 'react-bootstrap';
import Map from '../../../components/map/Map';
import result from '../../../result';

function SkillsPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [reply, setReply] = useState('');
  const [color, setColor] = useState('');
  const onChangeName = (e) => {
    const name = e.target.value;
    setName(name);
  };

  const onChangeEmail = (e) => {
    const email = e.target.value;
    setEmail(email);
  };

  const onChangeSubject = (e) => {
    const subject = e.target.value;
    setSubject(subject);
  };

  const onChangeMessage = (e) => {
    const message = e.target.value;
    setMessage(message);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = [name, message, email, subject];

    result.post('/marks.json', data).then((response) => {
      if (response.status == 200) {
        setColor('green');
        setReply('Thank you for reaching out, I will get back to you');
        setSubject('');
        setName('');
        setEmail('');
        setMessage('');
      }
    });
  };

  return (
    <div className={Style.body}>
      <div className={Style.title}>Contact me</div>
      <Row>
        <Col sm={7}>
          <div className={Style.subtitle}>
            I am interest in fulltime,remote and freelance opportunities -
            especially ambitious or large projects.
            <br /> However, if you have other request or question, dont hesitate
            to contact me using the form below.
          </div>
          <Form onSubmit={handleSubmit} className='mt-5'>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Control
                    className={Style.input}
                    type='text'
                    placeholder='Name'
                    name='name'
                    value={name}
                    onChange={onChangeName}
                  />
                </Form.Group>
              </Col>
              <Col>
                {' '}
                <Form.Group>
                  <Form.Control
                    className={Style.input}
                    type='email'
                    placeholder='Email'
                    name='email'
                    value={email}
                    onChange={onChangeEmail}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group>
              <Form.Control
                className={Style.input}
                type='text'
                placeholder='Subject'
                name='subject'
                value={subject}
                onChange={onChangeSubject}
              />
            </Form.Group>
            <Form.Group>
              <Form.Control
                className={Style.input}
                as='textarea'
                rows={3}
                placeholder='Message'
                type='text'
                name='message'
                value={message}
                onChange={onChangeMessage}
              />
            </Form.Group>
            <Button className={Style.submit} type='submit'>
              Submit{' '}
              <i
                style={{ color: 'rgb(255, 0, 191)' }}
                className='fa fa-paper-plane'
                aria-hidden='true'></i>
            </Button>
          </Form>
          {reply && (
            <Alert
              className='mt-3'
              variant={color == 'green' ? 'success' : 'danger'}
              onClose={() => setReply(false)}
              dismissible>
              {reply}
            </Alert>
          )}
        </Col>
        <Col>
          <div className={Style.contact}>
            <span>Address:</span> Lagos Nigeria.
          </div>
          <div className={Style.contact}>
            <span>Phone:</span> 07067000688 , 07080069783
          </div>
          <div className={Style.contact}>
            <span>Email:</span> falola0021@gmail.com
          </div>
          <div className={Style.map}>
            <Map />
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default SkillsPage;
